var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 10.76L5.99325 12.2733L6.65325 9.42001L4.43992 7.50001L7.35992 7.25334L8.49992 4.56001L9.63992 7.25334L12.5599 7.50001L10.3466 9.42001L11.0066 12.2733M15.1666 6.66001L10.3733 6.25334L8.49992 1.83334L6.62658 6.25334L1.83325 6.66001L5.46658 9.81334L4.37992 14.5L8.49992 12.0133L12.6199 14.5L11.5266 9.81334L15.1666 6.66001Z",
    fill: "#E95A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.704968cf99536149482c7fb39b1b61cf.svg";
export { ForwardRef as ReactComponent };